import { Link } from "react-router-dom";

const PHOENIX = "https://static.prod-images.emergentagent.com/jobs/f2933716-8a33-4553-905d-fbbd725a7c18/images/e0c72b5f9182b28b7902f27aa597402d2675c99ef7f7900f4e86a2e4b1fa88c0.png";

export const PhoenixMark = ({ className = "h-9 w-9" }) => (
  <img src={PHOENIX} alt="Barbistry phoenix" className={`${className} object-contain`} />
);

export const Logo = ({ className = "", onClick }) => (
  <Link to="/" onClick={onClick} className={`flex items-center gap-2.5 group ${className}`} data-testid="logo-home-link">
    <PhoenixMark className="h-9 w-9 transition-transform duration-300 group-hover:scale-110" />
    <span className="flex flex-col leading-none">
      <span className="font-display text-xl font-bold tracking-tight">
        Barb<span className="gold-text">istry</span>
      </span>
      <span className="text-[9px] tracking-[0.35em] text-[#D4AF37]/80 uppercase mt-1">Atelier</span>
    </span>
  </Link>
);
